import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Thu May 30 2019
 * @author Tomáš Leity
 */
import { NumberUtils, PriceFormulas } from '@logio/common-be-fe';
import defaultRenderer from '../renderers/DefaultRenderer';
import { bigdecimal } from '@logio/big-decimal';

var Formatters =
/*#__PURE__*/
function () {
  function Formatters() {
    _classCallCheck(this, Formatters);
  }

  _createClass(Formatters, null, [{
    key: "empty",

    /**
     * Converts nothing to empty string
     * @returns string
     */
    value: function empty() {
      return '';
    }
    /**
     * Converts number to percentage representation
     * @param value
     * @returns string
     */

  }, {
    key: "numberToPercentage",
    value: function numberToPercentage(_ref) {
      var value = _ref.value;

      if (!value) {
        return Formatters.empty();
      }

      return NumberUtils.numberToPercentage(value, true).toString();
    }
    /**
     * Default value formatter.
     * @author Jan Prokop
     */

  }, {
    key: "defaultFormatter",
    value: function defaultFormatter(params) {
      return defaultRenderer(params);
    }
    /**
     * Number formatter for use in excel export.
     * @author Jan Prokop
     */

  }, {
    key: "excelNumberFormatter",
    value: function excelNumberFormatter(params) {
      if (params.value != null) {
        try {
          var val = typeof params.value.toNumber !== 'function' ? bigdecimal(params.value) : params.value;

          if (params.colDef.round) {
            return PriceFormulas.roundDefault(val).toNumber();
          }

          return val.toNumber();
        } catch (e) {
          // value has unexpected type - print empty string
          return '';
        }
      }

      return '';
    }
  }]);

  return Formatters;
}();

export { Formatters as default };